var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiContext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19995 16V6.85782C3.19995 4.96441 4.63881 3.40623 6.48276 3.21876L6.85776 3.20001H16C23.0692 3.20001 28.7999 8.93077 28.7999 16C28.7999 23.0693 23.0692 28.8 16 28.8V26.4C21.7437 26.4 26.3999 21.7438 26.3999 16C26.3999 10.2563 21.7437 5.60001 16 5.60001H6.85776C6.16346 5.60001 5.59995 6.16352 5.59995 6.85782V16C5.59995 21.7438 10.2562 26.4 16 26.4V28.8C8.93071 28.8 3.19995 23.0693 3.19995 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4L11.6 15.45C11.35 15.55 11.2 15.75 11.2 16C11.2 16.25 11.35 16.45 11.6 16.55L14.4 17.6L15.45 20.45C15.55 20.65 15.75 20.8 16 20.8C16.25 20.8 16.45 20.65 16.55 20.45L17.6 17.6L20.45 16.55C20.65 16.45 20.8 16.25 20.8 16C20.8 15.75 20.65 15.55 20.45 15.45L17.6 14.4L16.55 11.55C16.45 11.35 16.25 11.2 16 11.2C15.75 11.2 15.55 11.35 15.45 11.55L14.4 14.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiContext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-context.32c7b055e7fc876a765d84716b34e9f1.svg";